export default () => {
  return `hsla(${Math.floor(Math.random() * 60) + 350}, ${Math.floor(
    Math.random() * 50
  ) + 50}%, ${Math.floor(Math.random() * 20) + 40}%, 0.2)`;
};
